module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAI0lEQVQ4y2NgGBTgPy4AksIrPYwMgCkkEVPRgNFYoNyAoQ0AruIKE5UP92EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_england.png
// module id = 1312
// module chunks = 0